import PropTypes from "prop-types";
import { Card } from "@mui/material";
import Grid from "@mui/material/Grid2";

// Componentes SUI
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

// Componentes
import CertificacionIngresos from "./certificacionIngresos";
import CartaLaboral from "./cartaLaboral";

const DocumentosLaborales = ({ procesoId, identificador, setError, clienteData }) => {
  // Ya no necesitamos esta validación aquí porque se hace en el padre
  return (
    <Card>
      <SuiBox p={2}>
        <SuiBox>
          <SuiTypography variant="caption" color="text">
            Documentos que certifican su vinculación laboral actual
          </SuiTypography>
        </SuiBox>
        <Grid container spacing={3} p={1}>
          <Grid size={6}>
            <CertificacionIngresos
              procesoId={procesoId}
              identificador={identificador}
              setError={setError}
            />
          </Grid>
          {clienteData?.tipo_trabajador === "EMPLEADO(A)" && (
            <Grid size={6}>
              <CartaLaboral
                procesoId={procesoId}
                identificador={identificador}
                setError={setError}
              />
            </Grid>
          )}
        </Grid>
      </SuiBox>
    </Card>
  );
};

DocumentosLaborales.propTypes = {
  procesoId: PropTypes.number.isRequired,
  identificador: PropTypes.string,
  setError: PropTypes.func.isRequired,
  clienteData: PropTypes.object,
};

export default DocumentosLaborales;
